import { createIconComponent } from '../../factory/create-icon-component';
export const ItalyIcon = createIconComponent(
  'ItalyIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4605_28282)">
      <path
        d="M15.6667 5H8.33329H1V19.9996H8.33329H15.6667H23V5H15.6667Z"
        fill="#F0F0F0"
      />
      <path d="M8.33316 5.00018H1V20H8.33316V5.00018Z" fill="#6DA544" />
      <path d="M22.9998 5.00012H15.6667V20H22.9998V5.00012Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_4605_28282">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
